const session = {
  state: () => ({
      session:null,
  }),
  mutations: {
      setSession(state,session){
      state.session = session
    },
   },
  actions: {},
  getters: { 
      session: (state) => state.session,
      userName: (state) => state.session.user
   }
}
export default session